// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 MENU CONTAINER */
.menu-desktop {
  width: 100%;
  height: 100vh;
  padding: 15px;
}

.menu-desktop.collapsed {
  padding: 0 12px;
  overflow-x: visible;
  margin: 0;
  background-color: #000;
  color: white;
  border: none;
  border-radius: 0;
  will-change: width, transform;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  white-space: nowrap; /* Prevent wrapping */
}

.logo-container {
  gap: 20px;
  padding-left: 12px;
  padding-right: 4px;
  overflow: visible;
  flex-shrink: 0;
}

.logo-container a {
  flex-shrink: 0;
}

.logo-container .collapse-btn {
  flex: 0 0 auto; /* No encoger; distancia al logo gobernada por el gap, no por el balance */
  margin-left: 6px;
}

.logo-expanded {
  width: 184px;
  height: 57px;
  display: block;
  object-fit: contain;
  object-position: left center;
  mix-blend-mode: lighten;
}

.collapse-btn-icon {
  width: 24px;
  height: 24px;
}

.collapse-btn-icon--expand {
  transform: scaleX(-1);
}

/* 🎨 ICON MENU STYLES (Collapsed) */
.menu-item {
  width: 100%;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #8c8c8c;
  box-sizing: border-box;
}

.menu-item img {
  /* Default: grey-ish or white */
  filter: brightness(0.6);
  transition: all 0.2s ease;
}

.menu-item:hover img,
.menu-item.active img {
  /* Active/Hover: Full color or specific logic */
  filter: brightness(1);
}

/* Specific fix for the orange highlight item in collapsed mode */
.menu-item.highlight-orange {
  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%);
  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
  border-radius: 6px !important;
  justify-content: center;
}

.menu-item.highlight-orange img {
  filter: brightness(0) invert(1); /* White icon */
  width: 24px !important; 
  max-width: 24px !important;
  height: 24px !important;
  max-height: 24px !important; 
  object-fit: contain !important;
  display: block !important;
  margin: 0 auto !important; /* Center horizontally */
}

/* Nav items: 4px vertical, 12px horizontal — icono 24x24 centrado */
.menu-nav-item {
  padding: 4px 12px !important;
}

/* Botón + : nunca muestra fondo naranja activo */
.menu-item-plus.active,
.menu-item-plus:active,
.menu-item-plus:hover {
  background: transparent !important;
  box-shadow: none !important;
}

/* Plus Button in Collapsed Mode */
.plus-btn-collapsed {
  width: 36px;
  height: 36px;
  background-color: #f09502;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 1.5rem;
  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
  transition: transform 0.2s;
}

.plus-btn-collapsed:hover {
  transform: scale(1.1);
}

.menu-item:hover {
  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%);
  color: white;
  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.25);
}

.menu-item.active,
.menu-item:active {
  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;
  color: white !important;
  position: relative;
}

.menu-item.active::before {
  display: none !important;
}

/* 🟢 EXPANDED MENU STYLES */
.menu-item-text {
  /* Figma: contenido 29px de alto + padding 4px vertical / 8px horizontal.
     Gap 16px entre opciones lo pone el contenedor .menu-scroll-content. */
  padding: 4px 8px;
  box-sizing: border-box;
  /* margin-bottom eliminado para usar el gap del flex container */
  border-radius: 12px;
  cursor: pointer;
  color: #8c8c8c;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
}

.menu-item-text:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: white;
}

.menu-item-text.active {
  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;
  color: white !important;
  position: relative;
}

/* Active Indicator for Expanded */
.menu-item-text.active::before {
  display: none !important;
}

.menu-item-text i {
  font-size: 1.2rem;
}

/* Espacio entre icono y texto en ítems del menú (ej. Cartera digital) */
.menu-item-link {
  gap: 0.75rem;
  min-width: 0; /* evita que flex desborde y cambie el espacio */
}
.menu-item-icon {
  margin-right: 0.35rem;
  flex-shrink: 0;
}

/* Submenus */
.submenu {
  padding-left: 3rem; /* Indent submenus */
  overflow: hidden;
}

.submenu a {
  display: block;
  padding: 8px 0;
  color: #6c757d;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
}

.submenu a:hover {
  color: white;
}

.submenu a.active-sub {
  color: #f09502;
  font-weight: 500;
}

/* Collapse Toggle Button */
.collapse-btn {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.2s;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.collapse-btn:hover {
  color: #f09502;
}

/* Chevron: espacio fijo entre título y flecha para que no cambie al expandir/activar */
.chevron-transition {
  transition: transform 0.3s ease;
  font-size: 0.8rem !important;
  margin-left: 0.75rem;
  flex-shrink: 0;
}

.chevron-transition.rotate {
  transform: rotate(180deg);
}

.menu-item img,
.menu-item-text img {
  filter: brightness(0) invert(1);
  transition: all 0.2s ease;
}

/* Iconos blancos en hover del menú colapsado (sobre gradient naranja).
   En el menú expandido (.menu-item-text) mantenemos el filtro de color
   sobre fondo neutro. */
.menu-item:hover:not(.active) img {
  filter: brightness(0) invert(1);
}

.menu-item-text:hover:not(.active) img {
  filter: brightness(1) sepia(1) hue-rotate(-50deg) saturate(5);
}

.menu-item.active img,
.menu-item-text.active img {
  filter: brightness(0) invert(1) !important;
}

/* 📱 Hide redundant elements */
.d-none {
  display: none !important;
}

/* 💰 BALANCE SECTION */
.balance-section {
  margin-top: 32px;
}

.balance-row {
  gap: 10px;
  min-width: 0;
  overflow: hidden;
}

.balance-section .balance-amount {
  font-weight: 400;
  line-height: 1.15;
  min-width: 0;
  flex: 1 1 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* Dynamic sizing based on balance magnitude */
.balance-section .balance-amount.balance-xs {
  font-size: 1.7rem !important; /* < 10.000  (e.g. "9,999.99 €") */
}
.balance-section .balance-amount.balance-s {
  font-size: 1.5rem !important; /* 10k–99k    (e.g. "99,999.99 €") */
}
.balance-section .balance-amount.balance-m {
  font-size: 1.3rem !important; /* 100k–999k  (e.g. "999,999.99 €") */
}
.balance-section .balance-amount.balance-l {
  font-size: 1.1rem !important; /* 1M+        (e.g. "9,999,999.99 €") */
}

/* Compact action buttons so balance has more breathing room */
.balance-actions {
  gap: 12px;
  flex-shrink: 0;
}

.balance-refresh-wrapper {
  width: 28.4px;
  height: 26.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.balance-refresh-icon {
  width: 28.4px;
  height: 26.2px;
  cursor: pointer;
  fill: #FF9600;
  transition: transform 0.3s;
}

.balance-add-btn {
  width: 40.625px !important;
  height: 40.625px !important;
  background: transparent;
  padding: 0;
  outline: none;
  border: none;
  flex-shrink: 0;
}

.balance-add-btn svg {
  width: 40.625px;
  height: 40.625px;
}

.balance-label-container {
  position: relative;
  height: 25px;
  margin-bottom: 1rem;
}

.balance-label {
  color: #ffffff; /* Pure white */
  font-size: 1.3rem; /* Larger title */
  font-weight: 400;
  max-width: 100%;
  height: 25px;
  line-height: 25px;
  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
}

.btn-icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}

.btn-icon-circle.orange {
  background-color: #f09502;
  color: #000000;
}

.btn-icon-circle.transparent {
  background-color: transparent;
  color: #f09502;
  border: 1px solid rgba(240, 149, 2, 0.3);
}

.btn-icon-circle i {
  font-size: 1.1rem;
}

/* 🔥 Highlight Orange (For Oportunidades) */
.highlight-orange {
  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  margin-bottom: 0 !important; /* Spacing below opportunites removed to match Figma */
}

.highlight-orange::before,
.menu-item-text.highlight-orange.active::before {
  display: none !important;
}

.highlight-orange img {
  filter: brightness(0) invert(1) !important; /* Make icon white */
  width: 24px !important; 
  max-width: 24px !important;
  height: 24px !important;
  max-height: 24px !important;
  object-fit: contain !important;
  display: block !important;
}

.highlight-orange span {
  font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/menu-desktop/menu-desktop.component.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,iDAAiD;EACjD,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,0EAA0E;EAC1F,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA,iEAAiE;AACjE;EACE,4DAA4D;EAC5D,6CAA6C;EAC7C,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B,EAAE,eAAe;EAChD,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA,oEAAoE;AACpE;EACE,4BAA4B;AAC9B;;AAEA,iDAAiD;AACjD;;;EAGE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,8CAA8C;AAChD;;AAEA;;EAEE,uEAAuE;EACvE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE;0EACwE;EACxE,gBAAgB;EAChB,sBAAsB;EACtB,gEAAgE;EAChE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,YAAY,EAAE,gDAAgD;AAChE;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,kBAAkB,EAAE,oBAAoB;EACxC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;wBAEwB;AACxB;EACE,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,4BAA4B,EAAE,kCAAkC;AAClE;AACA;EACE,4BAA4B,EAAE,oCAAoC;AACpE;AACA;EACE,4BAA4B,EAAE,qCAAqC;AACrE;AACA;EACE,4BAA4B,EAAE,uCAAuC;AACvE;;AAEA,8DAA8D;AAC9D;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,iBAAiB,EAAE,iBAAiB;EACpC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,4CAA4C;AAC5C;EACE,uEAAuE;EACvE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B,EAAE,sDAAsD;AACrF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C,EAAE,oBAAoB;EAChE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* 🎨 MENU CONTAINER */\n.menu-desktop {\n  width: 100%;\n  height: 100vh;\n  padding: 15px;\n}\n\n.menu-desktop.collapsed {\n  padding: 0 12px;\n  overflow-x: visible;\n  margin: 0;\n  background-color: #000;\n  color: white;\n  border: none;\n  border-radius: 0;\n  will-change: width, transform;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  white-space: nowrap; /* Prevent wrapping */\n}\n\n.logo-container {\n  gap: 20px;\n  padding-left: 12px;\n  padding-right: 4px;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.logo-container a {\n  flex-shrink: 0;\n}\n\n.logo-container .collapse-btn {\n  flex: 0 0 auto; /* No encoger; distancia al logo gobernada por el gap, no por el balance */\n  margin-left: 6px;\n}\n\n.logo-expanded {\n  width: 184px;\n  height: 57px;\n  display: block;\n  object-fit: contain;\n  object-position: left center;\n  mix-blend-mode: lighten;\n}\n\n.collapse-btn-icon {\n  width: 24px;\n  height: 24px;\n}\n\n.collapse-btn-icon--expand {\n  transform: scaleX(-1);\n}\n\n/* 🎨 ICON MENU STYLES (Collapsed) */\n.menu-item {\n  width: 100%;\n  padding: 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #8c8c8c;\n  box-sizing: border-box;\n}\n\n.menu-item img {\n  /* Default: grey-ish or white */\n  filter: brightness(0.6);\n  transition: all 0.2s ease;\n}\n\n.menu-item:hover img,\n.menu-item.active img {\n  /* Active/Hover: Full color or specific logic */\n  filter: brightness(1);\n}\n\n/* Specific fix for the orange highlight item in collapsed mode */\n.menu-item.highlight-orange {\n  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%);\n  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n  border-radius: 6px !important;\n  justify-content: center;\n}\n\n.menu-item.highlight-orange img {\n  filter: brightness(0) invert(1); /* White icon */\n  width: 24px !important; \n  max-width: 24px !important;\n  height: 24px !important;\n  max-height: 24px !important; \n  object-fit: contain !important;\n  display: block !important;\n  margin: 0 auto !important; /* Center horizontally */\n}\n\n/* Nav items: 4px vertical, 12px horizontal — icono 24x24 centrado */\n.menu-nav-item {\n  padding: 4px 12px !important;\n}\n\n/* Botón + : nunca muestra fondo naranja activo */\n.menu-item-plus.active,\n.menu-item-plus:active,\n.menu-item-plus:hover {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n/* Plus Button in Collapsed Mode */\n.plus-btn-collapsed {\n  width: 36px;\n  height: 36px;\n  background-color: #f09502;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #000000;\n  font-size: 1.5rem;\n  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n  transition: transform 0.2s;\n}\n\n.plus-btn-collapsed:hover {\n  transform: scale(1.1);\n}\n\n.menu-item:hover {\n  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%);\n  color: white;\n  box-shadow: 0 4px 10px rgba(240, 149, 2, 0.25);\n}\n\n.menu-item.active,\n.menu-item:active {\n  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;\n  color: white !important;\n  position: relative;\n}\n\n.menu-item.active::before {\n  display: none !important;\n}\n\n/* 🟢 EXPANDED MENU STYLES */\n.menu-item-text {\n  /* Figma: contenido 29px de alto + padding 4px vertical / 8px horizontal.\n     Gap 16px entre opciones lo pone el contenedor .menu-scroll-content. */\n  padding: 4px 8px;\n  box-sizing: border-box;\n  /* margin-bottom eliminado para usar el gap del flex container */\n  border-radius: 12px;\n  cursor: pointer;\n  color: #8c8c8c;\n  transition: all 0.2s ease;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.menu-item-text:hover {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: white;\n}\n\n.menu-item-text.active {\n  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;\n  color: white !important;\n  position: relative;\n}\n\n/* Active Indicator for Expanded */\n.menu-item-text.active::before {\n  display: none !important;\n}\n\n.menu-item-text i {\n  font-size: 1.2rem;\n}\n\n/* Espacio entre icono y texto en ítems del menú (ej. Cartera digital) */\n.menu-item-link {\n  gap: 0.75rem;\n  min-width: 0; /* evita que flex desborde y cambie el espacio */\n}\n.menu-item-icon {\n  margin-right: 0.35rem;\n  flex-shrink: 0;\n}\n\n/* Submenus */\n.submenu {\n  padding-left: 3rem; /* Indent submenus */\n  overflow: hidden;\n}\n\n.submenu a {\n  display: block;\n  padding: 8px 0;\n  color: #6c757d;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: color 0.2s;\n}\n\n.submenu a:hover {\n  color: white;\n}\n\n.submenu a.active-sub {\n  color: #f09502;\n  font-weight: 500;\n}\n\n/* Collapse Toggle Button */\n.collapse-btn {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: color 0.2s;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.collapse-btn:hover {\n  color: #f09502;\n}\n\n/* Chevron: espacio fijo entre título y flecha para que no cambie al expandir/activar */\n.chevron-transition {\n  transition: transform 0.3s ease;\n  font-size: 0.8rem !important;\n  margin-left: 0.75rem;\n  flex-shrink: 0;\n}\n\n.chevron-transition.rotate {\n  transform: rotate(180deg);\n}\n\n.menu-item img,\n.menu-item-text img {\n  filter: brightness(0) invert(1);\n  transition: all 0.2s ease;\n}\n\n/* Iconos blancos en hover del menú colapsado (sobre gradient naranja).\n   En el menú expandido (.menu-item-text) mantenemos el filtro de color\n   sobre fondo neutro. */\n.menu-item:hover:not(.active) img {\n  filter: brightness(0) invert(1);\n}\n\n.menu-item-text:hover:not(.active) img {\n  filter: brightness(1) sepia(1) hue-rotate(-50deg) saturate(5);\n}\n\n.menu-item.active img,\n.menu-item-text.active img {\n  filter: brightness(0) invert(1) !important;\n}\n\n/* 📱 Hide redundant elements */\n.d-none {\n  display: none !important;\n}\n\n/* 💰 BALANCE SECTION */\n.balance-section {\n  margin-top: 32px;\n}\n\n.balance-row {\n  gap: 10px;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.balance-section .balance-amount {\n  font-weight: 400;\n  line-height: 1.15;\n  min-width: 0;\n  flex: 1 1 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Dynamic sizing based on balance magnitude */\n.balance-section .balance-amount.balance-xs {\n  font-size: 1.7rem !important; /* < 10.000  (e.g. \"9,999.99 €\") */\n}\n.balance-section .balance-amount.balance-s {\n  font-size: 1.5rem !important; /* 10k–99k    (e.g. \"99,999.99 €\") */\n}\n.balance-section .balance-amount.balance-m {\n  font-size: 1.3rem !important; /* 100k–999k  (e.g. \"999,999.99 €\") */\n}\n.balance-section .balance-amount.balance-l {\n  font-size: 1.1rem !important; /* 1M+        (e.g. \"9,999,999.99 €\") */\n}\n\n/* Compact action buttons so balance has more breathing room */\n.balance-actions {\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.balance-refresh-wrapper {\n  width: 28.4px;\n  height: 26.2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.balance-refresh-icon {\n  width: 28.4px;\n  height: 26.2px;\n  cursor: pointer;\n  fill: #FF9600;\n  transition: transform 0.3s;\n}\n\n.balance-add-btn {\n  width: 40.625px !important;\n  height: 40.625px !important;\n  background: transparent;\n  padding: 0;\n  outline: none;\n  border: none;\n  flex-shrink: 0;\n}\n\n.balance-add-btn svg {\n  width: 40.625px;\n  height: 40.625px;\n}\n\n.balance-label-container {\n  position: relative;\n  height: 25px;\n  margin-bottom: 1rem;\n}\n\n.balance-label {\n  color: #ffffff; /* Pure white */\n  font-size: 1.3rem; /* Larger title */\n  font-weight: 400;\n  max-width: 100%;\n  height: 25px;\n  line-height: 25px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  margin: 0;\n}\n\n.btn-icon-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-icon-circle.orange {\n  background-color: #f09502;\n  color: #000000;\n}\n\n.btn-icon-circle.transparent {\n  background-color: transparent;\n  color: #f09502;\n  border: 1px solid rgba(240, 149, 2, 0.3);\n}\n\n.btn-icon-circle i {\n  font-size: 1.1rem;\n}\n\n/* 🔥 Highlight Orange (For Oportunidades) */\n.highlight-orange {\n  background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;\n  color: white !important;\n  border-radius: 8px !important;\n  margin-bottom: 0 !important; /* Spacing below opportunites removed to match Figma */\n}\n\n.highlight-orange::before,\n.menu-item-text.highlight-orange.active::before {\n  display: none !important;\n}\n\n.highlight-orange img {\n  filter: brightness(0) invert(1) !important; /* Make icon white */\n  width: 24px !important; \n  max-width: 24px !important;\n  height: 24px !important;\n  max-height: 24px !important;\n  object-fit: contain !important;\n  display: block !important;\n}\n\n.highlight-orange span {\n  font-weight: 600;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
